import usePageWrapperStyles from './styles';
import { PageWrapperProps } from './types';

const PageWrapper: React.FunctionComponent<PageWrapperProps> = (props) => {
  const { children, reference } = props;
  const classes = usePageWrapperStyles(props);

  const renderPageWrapper = () => {
    return (
      <main ref={reference} className={classes.pageWrapper}>
        {children}
      </main>
    );
  };

  return renderPageWrapper();
};

export default PageWrapper;
